import React, { useState } from 'react';

function SmartImage({
    src,
    alt,
    className = '',
    wrapperClassName = '',
    fallback = null,
    loading = 'lazy',
}) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);

    if (!src || hasError) {
        return fallback || (
            <div className={`flex items-center justify-center bg-slate-800 text-sm text-slate-400 ${wrapperClassName}`}>
                Gambar tidak tersedia
            </div>
        );
    }

    return (
        <div className={`relative overflow-hidden ${wrapperClassName}`}>
            {!isLoaded && (
                <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200" />
            )}
            <img
                src={src}
                alt={alt}
                loading={loading}
                decoding="async"
                onLoad={() => setIsLoaded(true)}
                onError={() => setHasError(true)}
                className={`${className} transition-opacity duration-500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
            />
        </div>
    );
}

export default SmartImage;
